import { SET_LICENSES, SET_LICENSE, RESET } from './actionTypes'
import { hangup } from '../otuVision/actions'

export function reset() {
  return { 
    type : RESET
  }
}

export function setActiveLicense( license ) {

  const data = {
    missionId : license.missionId
  }

  return ( dispatch, getState ) => {
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=mission.setCurrentMission',data,{
      responseType : 'json',
      noSysInteraction : true, 
      callback : function ( success ) {
          
          dispatch({
            type : SET_LICENSE,
            license
          })

          otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=goToProfile&force&rewriteState=1' )

        }
      } )
  }
}

export function getLicenses() {
  return (dispatch, getState) => {
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=license.getLicenses',{},{
      responseType : 'json',
      noSysInteraction : true, 
      callback : function ( licenses ) {
                  
          dispatch( {
            type : SET_LICENSES,
            licenses
          } )

          for (let [ id, license ] of Object.entries( licenses ) ) {

            if ( license.active ) {
              dispatch({
                type : SET_LICENSE,
                license
              })
            }
          }


        }
      } )
    }
}




